/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameWarnPrompt.vue?vue&type=template&id=02e90d0b&scoped=true"
import script from "./popGameWarnPrompt.vue?vue&type=script&lang=js"
export * from "./popGameWarnPrompt.vue?vue&type=script&lang=js"
import style0 from "./popGameWarnPrompt.vue?vue&type=style&index=0&id=02e90d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e90d0b",
  null
  
)

export default component.exports